
    import './styles.scoped.css';
    export default {
  "icon": "awsui_icon_k5dlb_4eja4_93",
  "top-navigation": "awsui_top-navigation_k5dlb_4eja4_111",
  "padding-box": "awsui_padding-box_k5dlb_4eja4_146",
  "medium": "awsui_medium_k5dlb_4eja4_156",
  "narrow": "awsui_narrow_k5dlb_4eja4_156",
  "virtual": "awsui_virtual_k5dlb_4eja4_167",
  "hidden": "awsui_hidden_k5dlb_4eja4_171",
  "\t": "awsui_\t_k5dlb_4eja4_1",
  "identity": "awsui_identity_k5dlb_4eja4_183",
  "identity-link": "awsui_identity-link_k5dlb_4eja4_186",
  "no-logo": "awsui_no-logo_k5dlb_4eja4_203",
  "logo": "awsui_logo_k5dlb_4eja4_207",
  "title": "awsui_title_k5dlb_4eja4_219",
  "inputs": "awsui_inputs_k5dlb_4eja4_234",
  "search": "awsui_search_k5dlb_4eja4_241",
  "search-expanded": "awsui_search-expanded_k5dlb_4eja4_245",
  "utilities": "awsui_utilities_k5dlb_4eja4_249",
  "utility-wrapper": "awsui_utility-wrapper_k5dlb_4eja4_260",
  "utility-type-button-link": "awsui_utility-type-button-link_k5dlb_4eja4_281",
  "utility-type-menu-dropdown": "awsui_utility-type-menu-dropdown_k5dlb_4eja4_285",
  "utility-type-button-primary-button": "awsui_utility-type-button-primary-button_k5dlb_4eja4_293",
  "utility-link-icon": "awsui_utility-link-icon_k5dlb_4eja4_301",
  "utility-button-external-icon": "awsui_utility-button-external-icon_k5dlb_4eja4_305",
  "offset-right-none": "awsui_offset-right-none_k5dlb_4eja4_309",
  "offset-right-l": "awsui_offset-right-l_k5dlb_4eja4_313",
  "offset-right-xxl": "awsui_offset-right-xxl_k5dlb_4eja4_317",
  "overflow-menu-drawer": "awsui_overflow-menu-drawer_k5dlb_4eja4_322",
  "overflow-menu": "awsui_overflow-menu_k5dlb_4eja4_322",
  "overflow-menu-header": "awsui_overflow-menu-header_k5dlb_4eja4_366",
  "overflow-menu-header-text": "awsui_overflow-menu-header-text_k5dlb_4eja4_373",
  "overflow-menu-header-text--secondary": "awsui_overflow-menu-header-text--secondary_k5dlb_4eja4_384",
  "overflow-menu-header-text--title": "awsui_overflow-menu-header-text--title_k5dlb_4eja4_390",
  "overflow-menu-back-button": "awsui_overflow-menu-back-button_k5dlb_4eja4_394",
  "overflow-menu-dismiss-button": "awsui_overflow-menu-dismiss-button_k5dlb_4eja4_398",
  "overflow-menu-control": "awsui_overflow-menu-control_k5dlb_4eja4_402",
  "overflow-menu-list-item-utility": "awsui_overflow-menu-list-item-utility_k5dlb_4eja4_441",
  "overflow-menu-control-link": "awsui_overflow-menu-control-link_k5dlb_4eja4_448",
  "overflow-menu-control-expandable-menu-trigger": "awsui_overflow-menu-control-expandable-menu-trigger_k5dlb_4eja4_451",
  "overflow-menu-list": "awsui_overflow-menu-list_k5dlb_4eja4_441",
  "overflow-menu-list-submenu": "awsui_overflow-menu-list-submenu_k5dlb_4eja4_482",
  "overflow-menu-list-item": "awsui_overflow-menu-list-item_k5dlb_4eja4_441",
  "overflow-menu-list-item-icon": "awsui_overflow-menu-list-item-icon_k5dlb_4eja4_490",
  "overflow-menu-list-item-text": "awsui_overflow-menu-list-item-text_k5dlb_4eja4_493",
  "overflow-menu-list-item-submenu": "awsui_overflow-menu-list-item-submenu_k5dlb_4eja4_502",
  "overflow-menu-list-item-dropdown-menu": "awsui_overflow-menu-list-item-dropdown-menu_k5dlb_4eja4_507",
  "overflow-menu-list-item-expandable": "awsui_overflow-menu-list-item-expandable_k5dlb_4eja4_510",
  "expanded": "awsui_expanded_k5dlb_4eja4_518"
};
  